export const insuranceOrder = ['Primary', 'Secondary', 'Tertiary'];
